import { useContext } from "solid-js"
import { createFragment, type ResultOf } from "@/graphql"

// We've split this file in two parts to limit the impact of this annoying warning.
// Providers are special, as they have two parts: the context and a hook. Consumers who
// use the context care about fragments (as they provide the data), but the consumers of
// the hook don't.
//
// In any case, we are indeed using the fragment in `readFragment`, but the check only
// cares about graphl queries. This is a shortcoming of the checker.
import { PostEditorContext, PostEditorFragment } from "./provider"

export type EditorPost = ResultOf<typeof PostEditorFragment>
export type EditorPostVersion = EditorPost["currentVersions"][number]

export function usePostEditor() {
  const context = useContext(PostEditorContext)
  const post = createFragment(PostEditorFragment, () => context?.post())

  if (!context) {
    throw new Error("usePostEditor must be used within PostEditorProvider")
  }

  return {
    ...context,
    post,
  }
}
